import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'nav';
const idGen = new IDGenerator('wm_pagination');

register('wm-pagination', (): IBuildTaskDef => {
    return {
        pre: (attrs: any) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmPagination #${counter}="wmPagination" data-identifier="pagination" aria-label="Page navigation" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
